const userActionTypes = {
  GET_INVITE_LL: 'GET_INVITE_LL',
  SET_INVITE_LL: 'SET_INVITE_LL',
  GET_VP: 'GET_VP',
  GET_RM: 'GET_RM',
  SET_VP: 'SET_VP',
  SET_RM: 'SET_RM',
  SET_VP_LIST_ERROR: 'SET_VP_LIST_ERROR',
  SET_RM_LIST_ERROR: 'SET_RM_LIST_ERROR',
  SET_PM_LIST_ERROR: 'SET_PM_LIST_ERROR',
  SET_ERR: 'GET_ERR',
  GET_PM: 'GET_PM',
  SET_PM: 'SET_PM',
  GET_USER_BUILDING: 'GET_USER_BUILDING',
  SET_USER_BUILDING: 'SET_USER_BUILDING',
  GET_USER_APP: 'GET_USER_APP',
  GET_USER_CLAIM: 'GET_USER_CLAIM',
  SET_USER_APP: 'SET_USER_APP',
  SET_USER_CLAIM: 'SET_USER_CLAIM',
  GET_USER_POLICY: 'GET_USER_POLICY',
  SET_USER_POLICY: 'SET_USER_POLICY',
  DEL_USERS: 'DEL_USERS',
  UPDATE_USER_PROPERTY: 'UPDATE_USER_PROPERTY',
  UPDATE_USER_PROPERTY_SUCCESS: 'UPDATE_USER_PROPERTY_SUCCESS',
  UPDATE_USER_PROPERTY_FAILURE: 'UPDATE_USER_PROPERTY_FAILURE',
  DEL_USER_SUCCESS: 'DEL_USER_SUCCESS',
  GET_ACTIVE_LL: 'GET_ACTIVE_LL',
  SET_ACTIVE_LL: 'SET_ACTIVE_LL',
  SET_ACTIVE_LANDLORD_ERROR: 'SET_ACTIVE_LANDLORD_ERROR',
  GET_LANDLORD_DETAIL: 'GET_LANDLORD_DETAIL',
  SET_LANDLORD_DETAIL: 'SET_LANDLORD_DETAIL',
  SET_LANDLORD_DETAIL_ERROR: 'SET_LANDLORD_DETAIL_ERROR',
  GET_DELEGATION_DETAIL: 'GET_DELEGATION_DETAIL',
  SET_DELEGATION_DETAIL: 'SET_DELEGATION_DETAIL',
  SET_DELEGATION_DETAIL_ERROR: 'SET_DELEGATION_DETAIL_ERROR',
  DEL_LANDLORD: 'DEL_LANDLORD',
  GET_LANDLORDTREE: 'GET_LANDLORDTREE',
  SET_LANDLORDTREE: 'SET_LANDLORDTREE',
  GET_VPTREE: 'GET_VPTREE',
  SET_VPTREE: 'SET_VPTREE',
  GET_USER_BUILDING_SEARCH: 'GET_USER_BUILDING_SEARCH',
  SET_USER_BUILDING_SEARCH: 'SET_USER_BUILDING_SEARCH',
  DELEGATION_MOVEOUT: 'DELEGATION_MOVEOUT',
  GET_RMTREE: 'GET_RMTREE',
  SET_RMTREE: 'SET_RMTREE',
  SET_TREE_LOADING: 'SET_TREE_LOADING',
  SET_TREE_FETCH_ERROR: 'SET_TREE_FETCH_ERROR',
  GET_USER_LIST: 'GET_USER_LIST',
  SET_USER_LIST: 'SET_USER_LIST',
};

export default userActionTypes;
